import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const supabaseUrl = "https://uqxuqcfqbegrkhttamfq.supabase.co";
export const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVxeHVxY2ZxYmVncmtodHRhbWZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU2ODY4MTksImV4cCI6MjA2MTI2MjgxOX0.E4vKDkRNDmceGIcAMXquFtjjXn6DtvSnl3onyhtPR6c";

// Production-safe Supabase client initialization
console.log('🔧 Initializing Supabase client...', {
  url: supabaseUrl,
  hasKey: !!supabaseAnonKey,
  env: import.meta.env.MODE
});

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false // Disable to prevent URL issues in production
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  },
  global: {
    headers: {
      'User-Agent': 'PHCSN-Website'
    }
  }
});

console.log('✅ Supabase client initialized successfully');